<template>
  <PageTemplate>
    <Loader v-if="!isLoaded"/>
    <div v-else>
      <BackButton
          :label="$t('general.button.back')"
          :to="{ name: 'travelExpensesPendingAndActiveListForCoordinator' }"
          marginBottom="5"/>

      <h6 class="element-header">
        {{ $t('travel_expenses.title') }}
      </h6>

      <div class="row mb-4">
        <div class="col-lg-8">
          <Summary
              v-if="travelExpenses.id"
              :travelExpenses="travelExpenses"
              :isHr="isHr"
              :isHrAndCoordinator="isHrAndCoordinator"
              @approveTravelExpenses="submitForApprovalModal"
              @declineTravelExpenses="submitForDeclineModal"/>

          <ItemList
              v-if="travelExpenses.id"
              :travelExpenses="travelExpenses"
              :items="items"/>
        </div>
        <div class="col-lg-4 col-md-12 col-sm-12">
          <Mesagges v-if="travelExpenses.id" :travelExpenses="travelExpenses"/>
        </div>

      </div>
    </div>

    <ModalConfirm
        v-model="showApprovalModal"
        :confirmationQuestion="t('general.approve_question')"
        header=""
        :onConfirm="approveTravelExpenses"/>

    <ModalDecline
        v-model="showDeclineModal"
        :confirmationQuestion="t('general.decline_question')"
        header=""
        :onConfirm="declineTravelExpenses"/>

  </PageTemplate>
</template>

<script setup>
import travelExpensesService from '@/api/TravelExpenses';
import Loader from '@/components/Loader.vue';
import ModalConfirm from '@/components/modal/ModalConfirm.vue';
import ModalDecline from '@/components/modal/ModalDecline.vue';
import PageTemplate from '@/components/PageTemplate.vue';
import {CloseToast, ErrorToast, SuccessToast} from '@/components/VueToast';
import ItemList from '@/views/App/TravelExpenses/Coordinator/Details/ItemList.vue';
import Mesagges from '@/views/App/TravelExpenses/Coordinator/Details/Mesagges.vue';
import Summary from '@/views/App/TravelExpenses/Coordinator/Details/Summary.vue';
import BackButton from '@/components/button/BackButton.vue';
import {onMounted, ref} from 'vue';
import {useI18n} from 'vue-i18n';
import {useRoute} from 'vue-router';

const {t} = useI18n();
const route = useRoute();
const showApprovalModal = ref(false);
const showDeclineModal = ref(false);
const isLoaded = ref(false);
const travelExpenses = ref({});
const travelExpensesId = ref(route?.params?.id);
const isHr = ref(false);
const isHrAndCoordinator = ref(false);
const approvalStatus = ref('');
const items = ref([]);

async function getTravelExpenses() {
  try {
    const {data} = await travelExpensesService.getTravelExpensesCoordinatorDetails(travelExpensesId.value);
    travelExpenses.value = data?.data?.travelExpenses;
    isHr.value = data?.data?.isHr;
    isHrAndCoordinator.value = data?.data?.isHrAndCoordinator;
  } catch (error) {
    if (error.response?.status === 403) {
      // await router.push({ name: 'travelExpensesListForCoordinator' });
    }
    await ErrorToast(error);
  }
}

function submitForApprovalModal(passedApprovalStatus) {
  CloseToast();
  showDeclineModal.value = false;
  showApprovalModal.value = true;
  approvalStatus.value = passedApprovalStatus;
}

function submitForDeclineModal() {
  CloseToast();
  showApprovalModal.value = false;
  showDeclineModal.value = true;
}

async function approveTravelExpenses() {
  try {
    await travelExpensesService.coordinatorTravelExpensesApprove(travelExpensesId.value, approvalStatus.value);

    showApprovalModal.value = false;
    showDeclineModal.value = false;
    await getTravelExpenses();
    SuccessToast(t('general.toasts.save_success'));
  } catch (error) {
    await ErrorToast(error);
  }
}

async function declineTravelExpenses() {
  try {
    await travelExpensesService.coordinatorTravelExpensesDecline(travelExpensesId.value);

    showApprovalModal.value = false;
    showDeclineModal.value = false;
    await getTravelExpenses();
    SuccessToast(t('general.toasts.save_success'));
  } catch (error) {
    await ErrorToast(error);
  }
}

async function getItems() {
  try {
    const {data} = await travelExpensesService.getItems(travelExpensesId.value);
    items.value = data?.data
  } catch (error) {
    await ErrorToast(error);
  }
}

onMounted(async () => {
  if (travelExpensesId.value) {
    await getTravelExpenses();
    await getItems()
  }
  isLoaded.value = true;

  CloseToast();
});

</script>

<style scoped>

</style>